import React, { useContext } from 'react';
import GlobalContext from '../../../../context/GlobalContext';
import ResetSection from '../../../components/pageComponents/login/ResetSection';
import {
  BaseStyled,
  LoginContainerStyled,
  LogoStyled,
} from '../login/login.styles';

export default function ResetAccount() {
  const { companyData } = useContext(GlobalContext);
  const baseURL = process.env.REACT_APP_API;
  const protocol =
    process.env.REACT_APP_NODE_ENV === 'development' ? 'http' : 'https';

  return (
    <BaseStyled>
      <LoginContainerStyled>
        <LogoStyled
          path={
            companyData?.logo?.url
              ? `${protocol}://${companyData?.subdomain}.${baseURL}${companyData?.logo.url}`
              : '/logo-full-color.svg'
          }
        />
      </LoginContainerStyled>
      <ResetSection />
    </BaseStyled>
  );
}
